import { compare } from '../../../../webmodule-common/other/clone';
import { emptyGuid } from '../../../../webmodule-common/other/api/guid';
import { getApiFactory } from '../../../api/api-injector';
import { ResultGetGeneratedQuoteRevenue } from '../../../api/supplier-api-interface-franchiseenetwork';

class GeneratedQuotesCache {
  _pageKey = this.pageKey('', '-1', []);
  _pagePromise: Promise<ResultGetGeneratedQuoteRevenue | null> | null = null;
  pageKey(
    startDate: string,
    endDate: string,
    branchIds: string[],
    userId?: string
  ): { startDate: string; endDate: string; branchIds: string[]; userId?: string } {
    return { startDate, endDate, branchIds, userId };
  }
  async getData(startDate: string, endDate: string, branchIds: string[], userId?: string) {
    const currentPage = this.pageKey(startDate, endDate, branchIds, userId);
    if (!compare(this._pageKey, currentPage)) {
      this._pageKey = currentPage;
      this._pagePromise = getApiFactory()
        .dataAggregation()
        .getGeneratedQuoteRevenue({
          startDate: startDate,
          endDate: endDate,
          branchIds: branchIds,
          assignedToUserId: userId ?? emptyGuid
        });
    }
    return await this._pagePromise;
  }
}

let _db: GeneratedQuotesCache | null = null;
export function flushGeneratedQuotesCache() {
  _db = null;
}
export function generatedQuotesCache(): GeneratedQuotesCache {
  if (!_db) {
    _db = new GeneratedQuotesCache();
  }
  return _db;
}
